export const viewTitle = "Журнал обработки ТК";
export const viewUniqKey = "tk-log";
